import { createSelector } from 'reselect'
import * as stateSelectors from './stateSelectors'

export const getMatch = createSelector([stateSelectors.getMatch], match => match);

export const getHistory = createSelector([stateSelectors.getHistory], history => history);

export const getLocation = createSelector([stateSelectors.getLocation], location => location);
